import { Wallet, Users, BarChart3, Landmark, ShieldCheck, Zap, BarChart2, Headphones } from "lucide-react";

const HERO = "/img/login-tower.jpg";

export function GoldLogo({ className = "h-20 w-20" }) {
  return (
    <svg viewBox="0 0 120 110" className={className} aria-label="Ayzal Traders logo">
      <defs>
        <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFF1B8" />
          <stop offset="0.45" stopColor="#E9B949" />
          <stop offset="1" stopColor="#A8741A" />
        </linearGradient>
      </defs>
      <path d="M58 4 L104 106 H82 L58 48 L34 106 H12 Z" fill="url(#gold)" />
      <path d="M2 92 C 40 62, 80 46, 118 22 C 92 48, 58 70, 14 100 Z" fill="url(#gold)" opacity="0.95" />
    </svg>
  );
}

const CARDS = [
  { icon: Wallet, title: "VI Virtual Balance", sub: "Real-time tracking", bg: "bg-emerald-500", ring: "border-emerald-400/40" },
  { icon: Users, title: "DSE Outstanding", sub: "Complete ledger", bg: "bg-blue-600", ring: "border-blue-400/40" },
  { icon: BarChart3, title: "FL Advance", sub: "Commission & recovery", bg: "bg-amber-500", ring: "border-amber-400/50" },
  { icon: Landmark, title: "Cash / Bank", sub: "Total control", bg: "bg-violet-600", ring: "border-violet-400/40" },
];
const BADGES = [[ShieldCheck, "Secure Access"], [Zap, "Fast & Accurate"], [BarChart2, "Data Driven Business"], [Headphones, "Always Supported"]];

export function LoginHero() {
  return (
    <div className="relative overflow-hidden bg-[#071431] text-white min-h-[560px] lg:min-h-screen order-2 lg:order-1" data-testid="login-hero">
      <img src={HERO} alt="Telecom tower at dusk" className="absolute inset-0 h-full w-full object-cover object-right opacity-90" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071431]/95 via-[#071431]/60 to-transparent" />
      <div className="relative flex flex-col h-full px-6 py-8 sm:px-12 sm:py-12 gap-8">
        <div className="flex items-center gap-4">
          <GoldLogo className="h-16 w-16 sm:h-24 sm:w-24 shrink-0" />
          <div>
            <div className="font-display font-extrabold text-2xl sm:text-4xl tracking-tight leading-none">
              AYZAL <span className="text-[#E9B949]">TRADERS</span>
            </div>
            <div className="text-xs sm:text-base tracking-[0.3em] mt-2 text-slate-200">VI DBR LEDGER</div>
            <div className="text-[9px] sm:text-[11px] tracking-[0.35em] mt-1 text-slate-400">DISTRIBUTOR BUSINESS REPORT</div>
          </div>
        </div>
        <div className="h-1 w-20 rounded-full bg-[#E9B949]" />
        <div>
          <h1 className="font-display font-extrabold leading-[1.02] text-4xl sm:text-5xl lg:text-6xl">
            <span className="text-[#E9B949]">Hisab Perfect.</span><br />Business Powerful.
          </h1>
          <p className="mt-4 text-base sm:text-xl text-slate-200">Smart Accounting. Clear Control. Bigger Growth.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl">
          {CARDS.map((c) => (
            <div key={c.title} className={`rounded-2xl border ${c.ring} bg-[#0B1B3F]/70 backdrop-blur-md p-4 text-center fade-up`}>
              <div className={`mx-auto h-12 w-12 rounded-full grid place-items-center ${c.bg}`}><c.icon className="h-6 w-6" /></div>
              <div className="mt-3 font-semibold text-sm leading-tight">{c.title}</div>
              <div className="text-[11px] text-slate-300 mt-1">{c.sub}</div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mt-auto">
          {BADGES.map(([Icon, label]) => (
            <div key={label} className="flex items-center gap-2 text-xs sm:text-sm text-slate-200">
              <Icon className="h-6 w-6 text-[#E9B949] shrink-0" /> {label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
